import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StadiumEventsHistoryDataItem } from 'teacher-ui-client/components/giraffe/charts/stadium-events/history'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StadiumEventsHistoryResponse {
  stadium_events_history: {
    student_id: number
    spelling: number
    grammar: number
    vocabulary: number
    usage: number
    accuracy: number
  }[]
}

export async function stadiumEventsHistory(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StadiumEventsHistoryDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('stadium_events_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StadiumEventsHistoryResponse>(url, query)
  if (!data) return null

  const { stadium_events_history } = data
  if (stadium_events_history.length === 0) return null

  return stadium_events_history
}
